module.exports = __webpack_public_path__ + "img/car_grey.06c095b8.svg";